import { useContext, useRef, useState } from "react"
import UserContext from "src/provider/state-manager/userProvider"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import ApiContext from "src/provider/API/call-service"
import { 
    AbsoluteContainer,
    AppSpan, AppText, Circle, CustomContainer, 
    FlexColumn, 
    FlexRow, GridContainer, Icon, ScreenTitle 
} from "src/style"
import CameraIcon from 'src/assets/svg/settings-camera-icon'
import { MdContentCopy } from "react-icons/md"
import {CopyToClipboard} from 'react-copy-to-clipboard';
import helpers from "src/utils/helpers"
import { Portal, AppCenterPopupPlusD2 } from "src/component"

export const MyAccountD2: React.FC<any> = ({close}) => {
    const {API} = useContext(ApiContext)
    const {user: {userInfo: {profileInfo}, uploadedProfilePics}, setUserProperty} = useContext(UserContext)
    const {notifier} = useContext(VisibilityContext)
    const [profilePics, setProfilePics] = useState<string>(uploadedProfilePics || profileInfo?.profilePictureUrl)
    const [input, setInput] = useState<any>({encodedImage: '', imageExtension: ''})
    const [isHover, setIsHover] = useState(false)

    const profilePicsRef = useRef<any>(null);

    async function handleFile (e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files instanceof FileList) {
            if(!helpers.isValidFileType(e.target.value)) {
                setInput({encodedImage: '', imageExtension: ''})
                return notifier.show('Only PNG, JPG and JPEG files are allowed', 'Validation Error')
            }

            const [imageUrl, fileNameSplit] = [URL.createObjectURL(e.target.files[0]), e.target.files[0].name.split('.')]
            let extension = fileNameSplit[fileNameSplit.length - 1]

            let uploadedFile = await helpers.compressImage(e.target.files[0])

            if (!uploadedFile) return notifier.show('Unable to compress large file size uploaded')

            helpers.convertFileToBase64(uploadedFile)
            .then(async result => {
                const response = await API.updateProfilePics({encodedImage: result, imageExtension: extension})
                if (response) {
                    await setUserProperty('uploadedProfilePics', response)
                    setProfilePics(imageUrl)  
                }     
            })
            .catch(err => {
                notifier.show(JSON.stringify(err), 'Validation Error')
            })
        }
    }

    return (
        <Portal>
            <AppCenterPopupPlusD2
                title='My Account' 
                height='57' overflow='hidden'
                contentHeight='57' zIndex='6'
                maxHeight='85'
                close={close} 
            >
                <ScreenTitle 
                    textSize="2" fontWeight="600"
                    color="#211121" bottomMargin="2.5"
                    className="module-row-title"
                >
                    My Account
                </ScreenTitle>
                <GridContainer>
                    <CustomContainer 
                        width="auto" sizeUnit="" bottomMargin="2.5"
                    >
                        <Circle 
                            size="15.3" overflow="hidden" 
                            radius="45"
                            bgColor='#0D968F'
                        >
                            { profilePics ?
                                <Icon src={profilePics} noResize minWidth='100' style={{objectFit: 'cover'}}/>
                                :
                                <AppText textSize='6' fontWeight='600' color='#ffffff'>
                                    {profileInfo?.firstName && profileInfo?.firstName[0]}
                                </AppText>
                            }
                        </Circle>
                        <AbsoluteContainer 
                            bottom="-0.2" right="-0.5"
                        >
                            <CameraIcon
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)} 
                                isHover={isHover}
                                onClick={() => profilePicsRef.current.click()}
                            />
                            <input 
                                type="file" name='profilePics' 
                                onChange={handleFile} 
                                ref={profilePicsRef} 
                                id="profile-pics" 
                                className="file-input" 
                            />
                        </AbsoluteContainer>
                    </CustomContainer>
                    <FlexColumn padding="1.5">
                        <AppText 
                            fontWeight="500" color="#101828" 
                            fontFamily="Gilmer-Semi-Bold"
                        >
                            {profileInfo?.firstName} {profileInfo?.lastName}
                        </AppText>
                        <AppText 
                            fontWeight="500" color="#101828" 
                            fontFamily="Gilmer-Semi-Bold" topMargin="1.5"
                        >
                            BVN: {profileInfo?.bvn}
                        </AppText>
                        <AppText 
                            fontWeight="500" color="#101828" 
                            fontFamily="Gilmer-Semi-Bold" topMargin="1.5"
                        >
                            {profileInfo?.emailAddress}
                        </AppText>
                        <AppText 
                            fontWeight="500" color="#101828" 
                            fontFamily="Gilmer-Semi-Bold" topMargin="1.5"
                        >
                            {profileInfo?.phoneNumber}
                        </AppText>
                        <FlexRow gap="1" topMargin="1.5" justifyContent="center">
                            <AppText 
                                fontWeight="500" color="#101828" 
                                fontFamily="Gilmer-Semi-Bold"
                            >
                                Referral Code: {profileInfo?.referralCode}
                            </AppText>
                            <CopyToClipboard 
                                text={profileInfo?.referralCode}
                                onCopy={() => notifier.show('Referral Code Copied', '', 'success')}
                            >
                                <AppSpan textSize="2" color="#0D968F" topMargin="-0.5">
                                    <MdContentCopy />
                                </AppSpan>
                            </CopyToClipboard>
                        </FlexRow>
                    </FlexColumn>
                </GridContainer>
            </AppCenterPopupPlusD2>
        </Portal>
    )
}